import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutImageTable extends Layout {
    buttonUploadImage: Button;
    sourceImages: DataSource;
    tableImages: Table;
}
